'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var calendarView_styles = require('./calendar-view.styles-be23bcc4.js');

var daysViewVariantsStyles = {
    primary: styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    border-bottom: 1px solid ", ";\n    border-right: 1px solid ", ";\n  "], ["\n    border-bottom: 1px solid ", ";\n    border-right: 1px solid ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.sharedMediumGrey;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.sharedMediumGrey;
    }),
    secondary: styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    border: 0 none;\n    margin: 0;\n\n    .day-cell {\n      border: 0 none;\n      border-radius: 50%;\n      transition: all .3s;\n\n      &-active{\n        color: ", ";\n        box-shadow: ", ";\n      }\n\n      &-inactive{\n        color: ", ";\n      }\n\n      &-available {\n        color: ", ";\n      }\n\n      &-available:hover,\n      &-current:hover {\n        background-color: ", ";\n      }\n    } "], ["\n    border: 0 none;\n    margin: 0;\n\n    .day-cell {\n      border: 0 none;\n      border-radius: 50%;\n      transition: all .3s;\n\n      &-active{\n        color: ", ";\n        box-shadow: ", ";\n      }\n\n      &-inactive{\n        color: ", ";\n      }\n\n      &-available {\n        color: ", ";\n      }\n\n      &-available:hover,\n      &-current:hover {\n        background-color: ", ";\n      }\n    } "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.white;
    }, function (_a) {
        var theme = _a.theme;
        return theme.shadows.depth_2;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyMediumAlt;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.fontColor;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyLight;
    }),
    flexUi: styled.css(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject([""], [""]))),
};
var DayViewWrapper = styled__default(calendarView_styles.DaysLayout)(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var variant = _a.variant;
    return daysViewVariantsStyles[variant];
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

exports.DayViewWrapper = DayViewWrapper;
